export default {
  // Componente visual - sin cadenas estáticas traducibles
}
